import Model from './Model';

export default class Allowance extends Model {
  resource() {
    return 'allowances';
  }
}
